import { render, staticRenderFns } from "./BoardFilters.vue?vue&type=template&id=42240160&scoped=true"
import script from "./BoardFilters.vue?vue&type=script&lang=js"
export * from "./BoardFilters.vue?vue&type=script&lang=js"
import style0 from "./BoardFilters.vue?vue&type=style&index=0&id=42240160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42240160",
  null
  
)

export default component.exports